import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from 'src/app/_services/report.service';
import { Component, OnInit } from '@angular/core';
import { end } from '@popperjs/core';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import * as moment from 'moment/moment';
import { DatePipe } from '@angular/common';
import { ProjectService } from 'src/app/_services/project.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-tag-report',
  templateUrl: './tag-report.component.html',
  styleUrls: ['./tag-report.component.scss']
})
export class TagReportComponent implements OnInit {

  projectId: any;
  toDate :any;
  fromDate :any;
  tagReport: any;
  status: any='ALL';
  tag: any='ALL';
  currentDate : any;

  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;

  testStatus = ['PASS','FAIL','INCONCLUSIVE','SKIPPED','BLOCKED','NOT RUN'];
  tagStatus= ['IMPORTANT','VERY_IMPORTANT','GOOD_TO_HAVE'];

  timeZoneData = new Array();
  availZone: any;
  tz: any = 'ALL'
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Tag Execution Report',
    data: undefined,
  }
  previousUrl: any=[];
  previousUrltemp: any;
  currentUrl: string;
  agentCheck: boolean;

  constructor(private report: ReportService,
    private activateRouter: ActivatedRoute,
    private toaster: ToastrService,
    private router:Router,
    private projectService: ProjectService,
    private datepipe : DatePipe,
    private memoryService: MemoryService,
    private homeService: HomeService,
    private urlService: UrlService) { }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.currentDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.initFromToDate();
    this.activateRouter.paramMap.subscribe((params) => {
      this.projectId = params.get('pid');
      this.projectService.getProjectById(this.projectId).subscribe((res) => {
        this.headerOptions.data = {
          projectId: this.projectId,
          projectName: res['projectName']
        };
        //set header details
        this.homeService.setHeaderOptions(this.headerOptions);
      });
    })
    this.loadTimeZone();
    this.getTagReport(this.projectId,this.fromDate,this.toDate,'ALL','ALL');
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }



initFromToDate()
{
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2,"0");
  var date  =  String(today.getDate()).padStart(2,"0")
  this.toDate = year + "-" + month + "-" + date;
  
  const now = new Date();
  var lastWeek = new Date(now.getFullYear(), now.getMonth(), 1);
  var year1 = lastWeek.getFullYear();
  var month1 = String(lastWeek.getMonth() + 1).padStart(2,"0");
  var date1  =  String(lastWeek.getDate()).padStart(2,"0")
  this.fromDate = year1 + "-" + month1 + "-" + date1;
}


getTagReport(projectid,startDate,endDate,status,tag){
  let endDate1 =  new Date(JSON.parse(JSON.stringify(endDate)));
    endDate1.setHours(23,59,59);
    let startDate1 =  new Date(JSON.parse(JSON.stringify(startDate)));
    startDate1.setHours(24,0,0);
  let fromDate = Math.floor(new Date(startDate1).getTime());
  let toDate =   Math.floor(new Date(endDate1).getTime());
  this.report.tagExecutionReport(projectid,fromDate,toDate,status,tag).subscribe((data) => {
      if(data['testExecutionStats']){
        this.tagReport = data['testExecutionStats'];
      }else{
        this.tagReport = []
        this.toaster.clear();
        this.toaster.warning('No execution report found')
        
        
      }
  })
}

onFilterReport(updateReportForm){
  //console.log(updateReportForm.value)
  
  let fromDate = Math.floor(new Date(updateReportForm.value.fromDate).getTime());
  let toDate =   Math.floor(new Date(updateReportForm.value.toDate).getTime());
  let e = new Date(this.currentDate).getTime();
  if(fromDate > e || toDate > e)
  {
    this.toaster.clear();
    this.toaster.info('Please select current or past date');
    return
  }
  
  if(toDate < fromDate){
    this.toaster.clear();
    this.toaster.info('Please select end date after start date');
    return;
  }
 
  this.getTagReport(this.projectId,fromDate,toDate,this.status,this.tag);
}
statusValue(value){
  this.status = value;
}
tagValue(value){
  this.tag = value;
}

onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}

tagTestCaseSummary(reportId){
  this.router.navigate(['/tagTestCaseReport/'+this.projectId+'/'+reportId]);
}
loadTimeZone = function () {
  var timeZones = moment.tz.names();
  if (timeZones) {
      for (var i = 0; i < timeZones.length; i++) {
          var data = new Object();
          data['key'] = timeZones[i];
          data['value'] = timeZones[i];
          this.timeZoneData.push(data);
          //console.log('timeZoneData',this.timeZoneData);
          this.availZone = {
            collections: {
              field: this.timeZoneData
          }
          }
          //console.log('availZone',this.availZone);
          
      }
  }
};
tzValue(value){
  this.tz = value;
}

}
